import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { authReducer } from './authSlice';

const persistConfig = {
  key: 'auth',
  storage,
  whitelist: ['auth'],
};

const reducer = combineReducers({
  auth: authReducer,
});

export const persistedAuthReducer = persistReducer(persistConfig, reducer);
